import { createModule } from '@Actions/utils';
import { SERVICE_ENDPOINT } from '@Apis/constants';

const UpdateExportDetails = createModule({
  base: 'UPDATE_EXPORT_DETAILS',
  apiDetails: { ...SERVICE_ENDPOINT.EXPORT_DETAILS, method: 'put' },
  errors: { defaultError: true, customError: '' },
  enableNotification: true,
  customNotificationSuccessMessage: 'Export Details updated successfully',
});

const GetExportDetails = createModule({
  base: 'GET_EXPORT_DETAILS',
  apiDetails: { ...SERVICE_ENDPOINT.EXPORT_DETAILS, method: 'get' },
  errors: { defaultError: true, customError: '' },
});

export {
  UpdateExportDetails,
  GetExportDetails,
};
